import { HunterAffiliatePageContent } from "Components/Affiliate/Hunter/HunterAffiliatePageContent";
import { CustomerAffiliatePageContent } from "Components/Affiliate/Customer/CustomerAffiliatePageContent";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useCurrentUserRole } from "Hooks/useCurrentUserAccessRole";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";
import { MerchantAffiliatePageContent } from "Components/Affiliate/Merchant/MerchantAffiliatePageContent";
import { Stack } from "@mui/material";
import type { FC } from "react";
import type { AccessRoleCode } from "Models/AccessRoleCodes";
import { useIsMobile } from "Hooks/useIsMobile";

const NoContent = () => null;

const USER_ROLE_TO_CONTENT_MAP: Record<AccessRoleCode, FC> = {
  Hunter: HunterAffiliatePageContent,
  Customer: CustomerAffiliatePageContent,
  Merchant: MerchantAffiliatePageContent,
  Employee: NoContent,
  Admin: NoContent,
  AdminLite: NoContent,
  Aml: NoContent,
  CustomerOnboarding: NoContent,
  HunterPlus: HunterAffiliatePageContent,
  Disponent: NoContent,
  Child: NoContent,
};

export const AffiliatePage = () => {
  const userRole = useCurrentUserRole();
  const { t } = useResource();
  const isMobile = useIsMobile();

  const AffiliatePageContent = userRole
    ? USER_ROLE_TO_CONTENT_MAP[userRole]
    : NoContent;

  return (
    <AuthenticatedLayout
      title={t(Resources.Pages.Titles.ThanksToYou)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: isMobile ? appUrl("dashboard") : null, // "root" page, nowhere higher to go
      }}
    >
      <StyledPageWrapper>
        <div className="left-content">
          <Stack gap={6}>
            <AffiliatePageContent />
          </Stack>
        </div>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default AffiliatePage;
